import React from 'react';
import ScriptLoader from 'react-script-loader-hoc';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Dropdown from '../../components/Dropdown';
import Form from '../../components/Form';
import Icon from '../../components/Icon';
import Input from '../../components/Input';
import Label from '../../components/Label';
import Button from '../../components/Button';
import Dimmer from '../../components/Dimmer';
import Header from '../../components/Header';
import Modal from '../../components/Modal';
import Grid from '../../components/Grid';
import Item from '../../components/Item';
import Image from '../../components/Image';

import messages from './messages';
import planAndOrganizeImg from './Calendar.png';
import recommendationsImg from './Target.png';
import contactsImg from './Contacts.png';
import optimizeTravelImg from './Travel.png';
import successImg from './success.svg';
import { validateFields, elementIds } from '../../utils/upgradeForm';
import { loadMarketoForm, renderMarketoForm, submitMarketoForm } from '../../utils/marketoForm';

import { MARKETO_SCRIPT_URL, MARKETO_UPGRADE_FORM } from '../UpgradeForm/constants';

import { ELOQUA_URL, CAMPAIGN_ID_REPVISITS, MARKETO_CAMPAIGN_ID, LEAD_SOURCE_REPVISITS, PRIVACY_URL } from './constants';
import './styles.css';
import jobLevelOptions from '../SubscriptionUpgradeForm/jobLevelOptions';
import jobTopicOptions from '../SubscriptionUpgradeForm/jobTopicOptions';
import withGlobals from '../../components/Globals';
import { ADD_JOB_TOPIC_FIELD, MODIFY_MESSAGE_FIELD } from '../Authorization/constants';

const marketoUrl = MARKETO_SCRIPT_URL;
const { origin } = new URL(marketoUrl);
global.__webpack_marketo_public_path__ = origin;

class RepVisitsUpgradeForm extends React.PureComponent {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    viewer: PropTypes.object.isRequired,
    marketoUtils: PropTypes.shape({
      loadMarketoForm: PropTypes.func.isRequired,
      submitMarketoForm: PropTypes.func.isRequired,
      renderMarketoForm: PropTypes.func.isRequired,
    }),
    scriptsLoadedSuccessfully: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    if (this.props.open) {
      this.trackModalOpen();
    }
    this.addJobTopicField = this.props.viewer?.enabledFeatures?.includes(ADD_JOB_TOPIC_FIELD);
    this.modifyMessageField = this.props.viewer?.enabledFeatures?.includes(MODIFY_MESSAGE_FIELD);
  }

  getInitialState = () => {
    const { viewer } = this.props;
    return {
      firstName: viewer.firstName,
      lastName: viewer.lastName,
      emailAddress: viewer.email,
      phone: viewer.phone,
      errors: {},
      success: false,
      currentCount: 10,
      timer: null,
      jobLevel: '',
      jobTopic: '',
      notes: '',
      optIn: false,
      jobLevelError: false,
      jobTopicError: false,
      useMarketoUpgradeForm: viewer.enabledFeatures?.includes(MARKETO_UPGRADE_FORM),
      scriptsLoadedSuccessfully: false,
    };
  };

  componentWillReceiveProps(nextProps) {
    const { open, marketoUtils } = this.props;
    if (!open && nextProps.open) {
      this.trackModalOpen();
    }
    if (!this.state.scriptsLoadedSuccessfully &&
        nextProps.scriptsLoadedSuccessfully &&
        nextProps.viewer.enabledFeatures?.includes(MARKETO_UPGRADE_FORM)) {
      marketoUtils ? marketoUtils.loadMarketoForm(this) : loadMarketoForm(this); // eslint-disable-line no-unused-expressions
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  onChange = (e, { value, name } = {}) => {
    value = value || e.target.value;
    name = name || e.target.name;
    if (e.target.type === 'checkbox') {
      value = !this.state[name]; // e.target.checked does not work in unit tests
    }
    this.setState({ [name]: value });
  };

  onSuccess = () => {
    /** Emitting GA event */
    window.dataLayer.push({
      event: 'trackEvent',
      eventCategory: 'User Engagement',
      eventAction: 'eloqua-lead-gen-submitted',
      userId: this.props.viewer.uuid,
    });

    this.setState({
      timer: setInterval(this.countDown, 1000),
      success: true,
    });
  };

  trackModalOpen() {
    /** Emitting GA event */
    window.dataLayer.push({
      event: 'trackEvent',
      eventCategory: 'User Engagement',
      eventAction: 'eloqua-lead-gen-load',
      userId: this.props.viewer.uuid,
    });
  }

  stopTimer = () => {
    clearInterval(this.state.timer);
  };

  countDown = () => {
    if (this.state.currentCount === 1) {
      this._close();
    } else {
      this.setState((prevState) => ({
        currentCount: prevState.currentCount - 1,
      }));
    }
  };

  onChangeMenuDropdown = (key, value) => {
    this.setState({ [`${key}Error`]: false, [key]: value });
  }

  _close = () => {
    const { onClose } = this.props;
    this.stopTimer();
    onClose();
    this.setState(this.getInitialState());
  };

  _validateForm = (event) => {
    const { jobLevel, jobTopic, useMarketoUpgradeForm } = this.state;
    if (!jobLevel) {
      this.setState({ jobLevelError: true });
    }
    if (this.addJobTopicField && !jobTopic) {
      this.setState({ jobTopicError: true });
    }

    // eslint-disable-next-line react/no-access-state-in-setstate
    const errors = validateFields(this.state, this.addJobTopicField, this.modifyMessageField);
    this.setState({ errors });
    if (Object.keys(errors).some((key) => errors[key])) {
      event.preventDefault();
    } else {
      if (useMarketoUpgradeForm) { // eslint-disable-line no-lonely-if
        const { viewer, marketoUtils } = this.props;
        /* eslint-disable no-unused-expressions */
        marketoUtils ?
          marketoUtils
            .submitMarketoForm(viewer, this.state, MARKETO_CAMPAIGN_ID, LEAD_SOURCE_REPVISITS, this.onSuccess, this.addJobTopicField) :
          submitMarketoForm(viewer, this.state, MARKETO_CAMPAIGN_ID, LEAD_SOURCE_REPVISITS, this.onSuccess, this.addJobTopicField);
        /* eslint-enable no-unused-expressions */
      } else {
        this.onSuccess();
      }
    }
  };

  render() {
    const { viewer, open, intl, marketoUtils } = this.props;
    const { formatMessage } = intl;
    const {
      firstName,
      lastName,
      emailAddress,
      phone,
      errors,
      success,
      currentCount,
      jobLevelError,
      jobTopicError,
      notes,
      optIn,
      jobLevel,
      jobTopic,
      useMarketoUpgradeForm,
    } = this.state;
    const upgrade = formatMessage(messages.upgrade);
    const header = formatMessage(messages.header);
    const planAndOrganizeAlt = formatMessage(messages.planAndOrganizeAlt);
    const recommendationsAlt = formatMessage(messages.recommendationsAlt);
    const contactsAlt = formatMessage(messages.contactsAlt);
    const optimizeTravelAlt = formatMessage(messages.optimizeTravelAlt);
    const successAlt = formatMessage(messages.successAlt);
    const offerCampaignId = CAMPAIGN_ID_REPVISITS;

    return (
      <Dimmer.Dimmable
        role="dialog"
        aria-label={`${upgrade} ${header}`}
        as={Modal}
        open={open}
        id="upgrade-form"
        onClose={this._close}
        closeIcon="close"
      >
        <Header styleName="header">
          <span styleName="header-bold">{upgrade}</span> {header}
        </Header>
        <Modal.Content styleName="no-padding">
          <Grid
            as={Form}
            onSubmit={this._validateForm}
            method="post"
            action={useMarketoUpgradeForm ? undefined : ELOQUA_URL}
            target="bgsubmit"
            autoComplete="off"
            styleName="no-margin"
            stackable
            data-cy="repvisits-upgrade-form"
          >
            <Grid.Row styleName="no-padding">
              <Grid.Column width={8} verticalAlign="middle" styleName="premiun-actions">
                <Item.Group>
                  <Item styleName="item">
                    <Header as="h3" styleName="sub-header">
                      <FormattedMessage {...messages.unlockPowerfulFeatures} />
                    </Header>
                  </Item>
                  <Item styleName="item">
                    <Item.Image size="mini" src={planAndOrganizeImg} alt={planAndOrganizeAlt} styleName="mobile-centered-img" />
                    <Item.Content verticalAlign="middle"><FormattedMessage {...messages.planAndOrganize} /></Item.Content>
                  </Item>
                  <Item styleName="item">
                    <Item.Image size="mini" src={recommendationsImg} alt={recommendationsAlt} styleName="mobile-centered-img" />
                    <Item.Content verticalAlign="middle"><FormattedMessage {...messages.recommendations} /></Item.Content>
                  </Item>
                  <Item styleName="item">
                    <Item.Image size="mini" src={contactsImg} alt={contactsAlt} styleName="mobile-centered-img" />
                    <Item.Content verticalAlign="middle"><FormattedMessage {...messages.contacts} /></Item.Content>
                  </Item>
                  <Item styleName="item">
                    <Item.Image size="mini" src={optimizeTravelImg} alt={optimizeTravelAlt} styleName="mobile-centered-img" />
                    <Item.Content verticalAlign="middle"><FormattedMessage {...messages.optimizeTravel} /></Item.Content>
                  </Item>
                  <Item styleName="item-no-img">
                    <Item.Content verticalAlign="middle"><FormattedMessage {...messages.andMore} /></Item.Content>
                  </Item>
                  <Item styleName="item">
                    <Item.Content verticalAlign="middle"><FormattedMessage {...messages.representative} /></Item.Content>
                  </Item>
                </Item.Group>
              </Grid.Column>
              <Grid.Column width={8} verticalAlign="middle" styleName={(success ? 'hidden-form' : 'full-height padding-bottom')}>
                {!useMarketoUpgradeForm && (
                  <React.Fragment>
                    <input type="hidden" name="elqFormName" value="standardGlobal" />
                    <input type="hidden" name="elqSiteId" value="2203" />
                    <input type="hidden" id="field0" name="redirectURL" value="" />
                    <input type="hidden" id="field5" name="offerCampaignId" value={offerCampaignId} />
                    <input type="hidden" id="field11" name="Market" value="Matching" />
                    <input type="hidden" id="field19" name="leadSource" value="Information Request" />
                    <input type="hidden" id="field21" name="country" value={viewer.institution.field_country || 'United States'} />
                    <input type="hidden" id="field22" name="jobLevel" value={jobLevel} />
                    {this.addJobTopicField && <input type="hidden" id="topic" name="jobTopic" value={jobTopic} />}
                    <input type="hidden" id="field23" name="institutionState" value={get(viewer, 'institution.field_state_short_name')} />
                  </React.Fragment>
                )}
                <Header as="h3" styleName="sub-header">
                  <FormattedMessage {...messages.contactInformation} />
                </Header>
                <div styleName="note">
                  <FormattedMessage {...messages.note} />
                </div>
                <Form.Field required error={errors.firstName}>
                  <label styleName="form-label" htmlFor={elementIds.firstName}>
                    <FormattedMessage {...messages.firstName} />
                  </label>
                  <Input styleName="form-input" type="text" name="firstName" value={firstName || ''} onChange={this.onChange} fluid>
                    <input id={elementIds.firstName} aria-invalid={errors.firstName} aria-required="true" />
                  </Input>
                  {errors.firstName && (
                  <Label role="tooltip" basic color="red" pointing data-cy="upgrade-form-first-name">
                    <FormattedMessage {...messages.enterValue} />
                  </Label>
                  )}
                </Form.Field>
                <Form.Field required error={errors.lastName}>
                  <label styleName="form-label" htmlFor={elementIds.lastName}>
                    <FormattedMessage {...messages.lastName} />
                  </label>
                  <Input styleName="form-input" type="text" name="lastName" value={lastName || ''} onChange={this.onChange} fluid>
                    <input id={elementIds.lastName} aria-invalid={errors.lastName} aria-required="true" />
                  </Input>
                  {errors.lastName && (
                  <Label role="tooltip" basic color="red" pointing data-cy="upgrade-form-last-name">
                    <FormattedMessage {...messages.enterValue} />
                  </Label>
                  )}
                </Form.Field>
                <Form.Field required error={errors.emailAddress || errors.invalidEmail}>
                  <label styleName="form-label" htmlFor={elementIds.emailAddress}>
                    <FormattedMessage {...messages.email} />
                  </label>
                  <Input styleName="form-input" type="email" name="emailAddress" value={emailAddress || ''} onChange={this.onChange} fluid>
                    <input id={elementIds.emailAddress} aria-invalid={errors.emailAddress || errors.invalidEmail} aria-required="true" />
                  </Input>
                  {errors.emailAddress && (
                  <Label role="tooltip" basic color="red" pointing data-cy="upgrade-form-email-address">
                    <FormattedMessage {...messages.enterValue} />
                  </Label>
                  )}
                  {errors.invalidEmail && (
                  <Label role="tooltip" basic color="red" pointing>
                    <FormattedMessage {...messages.invalidEmail} />
                  </Label>
                  )}
                </Form.Field>
                <Form.Field error={errors.invalidPhone}>
                  <label styleName="form-label" htmlFor={elementIds.phone}>
                    <FormattedMessage {...messages.phone} />
                  </label>
                  <Input styleName="form-input" type="tel" name="phone" value={phone || ''} onChange={this.onChange} fluid>
                    <input id={elementIds.phone} aria-invalid={errors.invalidPhone} autoComplete="phone" />
                  </Input>
                  {errors.invalidPhone && (
                  <Label role="tooltip" basic color="red" pointing>
                    <FormattedMessage {...messages.invalidPhone} />
                  </Label>
                  )}
                </Form.Field>
                <Form.Field required>
                  <label styleName="form-label" htmlFor={elementIds.company}>
                    <FormattedMessage {...messages.company} />
                  </label>
                  <Input styleName="form-input" type="text" name="company" value={get(viewer, 'institution.name', '')} fluid icon>
                    <input id={elementIds.company} aria-required="true" styleName="fake-disabled-input" required readOnly />
                    <Icon name="lock" />
                  </Input>
                </Form.Field>
                <Form.Field required>
                  <label htmlFor={elementIds.jobLevel} style={{ fontWeight: 'normal' }}>
                    <FormattedMessage {...messages.jobLevel} />
                  </label>
                  <Dropdown
                    className="upgrade-form-dropdown"
                    id={elementIds.jobLevel}
                    name="jobLevel"
                    placeholder="Select Job Level"
                    fluid
                    selection
                    options={jobLevelOptions}
                    aria-required="true"
                    onChange={(ev, { value }) => { this.onChangeMenuDropdown('jobLevel', value); }}
                    error={jobLevelError}
                  />
                </Form.Field>
                {this.addJobTopicField && (
                  <Form.Field required>
                    <label htmlFor={elementIds.jobTopic} style={{ fontWeight: 'normal' }}>
                      <FormattedMessage {...messages.jobTopic} />
                    </label>
                    <Dropdown
                      className="upgrade-form-dropdown"
                      id={elementIds.jobTopic}
                      name="jobTopic"
                      placeholder="Select type of request"
                      fluid
                      selection
                      options={jobTopicOptions}
                      aria-required="true"
                      onChange={(ev, { value }) => { this.onChangeMenuDropdown('jobTopic', value); }}
                      error={jobTopicError}
                    />
                  </Form.Field>
                )}
                {!this.modifyMessageField && (
                  <Form.Field>
                    <label styleName="form-label" htmlFor={elementIds.notes}>
                      Message (optional)
                    </label>
                    <textarea
                      styleName="form-input"
                      id={elementIds.notes}
                      name="notes"
                      rows="3"
                      value={notes || ''}
                      onChange={this.onChange}
                    />
                  </Form.Field>
                )}
                {this.modifyMessageField && (
                  <Form.Field className="field-notes" required>
                    <label styleName="form-label" htmlFor={elementIds.notes}>
                      <FormattedMessage {...messages.notes} />
                    </label>
                    <textarea
                      styleName="form-input"
                      id={elementIds.notes}
                      name="notes"
                      rows="3"
                      value={notes || ''}
                      onChange={this.onChange}
                      aria-invalid={errors.notes}
                      aria-required="true"
                    />
                    {errors.notes && (
                      <Label role="tooltip" basic color="red" pointing data-cy="notes-validation-error">
                        <FormattedMessage {...messages.enterValue} />
                      </Label>
                    )}
                  </Form.Field>
                )}
                <Form.Field>
                  <div className="ui checkbox">
                    <input type="checkbox" className="ui checkbox" id={elementIds.optIn} name="optIn" checked={optIn} onChange={this.onChange} />
                    <label styleName="form-label" htmlFor={elementIds.optIn}>
                      <FormattedMessage {...messages.hobsonsCommunication} />
                    </label>
                  </div>
                </Form.Field>
              </Grid.Column>
              {success && (
              <Grid.Column
                width={8}
                verticalAlign="middle"
                styleName="success-message"
                data-cy="repvisits-upgrade-success-msg"
              >
                <Image src={successImg} alt={successAlt} centered />
                <b><FormattedMessage {...messages.thanksTitle} /></b>
                <p><FormattedMessage {...messages.thanksMessage} /></p>
              </Grid.Column>
              )}
            </Grid.Row>
            <Grid.Row styleName="no-padding">
              <Grid.Column styleName="footer">
                {!success && (
                <div>
                  <Button type="submit" color="pink">
                    <FormattedMessage {...messages.requestInformation} />
                  </Button>
                  <div>
                    <a styleName="privacy-link" href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">Privacy Statement</a>
                  </div>
                </div>
                )}
                {success && <FormattedMessage {...messages.closingCount} values={{ count: currentCount }} />}
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {useMarketoUpgradeForm && (marketoUtils ? marketoUtils.renderMarketoForm() : renderMarketoForm())}
          <iframe title="hidden" styleName="hidden" name="bgsubmit" id="bgsubmit" />
        </Modal.Content>
      </Dimmer.Dimmable>
    );
  }
}

export const RepVisitsUpgradeFormComponent = injectIntl(RepVisitsUpgradeForm);

export default withGlobals(ScriptLoader(marketoUrl)(RepVisitsUpgradeFormComponent));
